var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",class:_vm.activeClass,attrs:{"to":_vm.path,"exact":_vm.path === '/',"active-class":"active"}},[_c('div',{staticClass:"d-flex align-items-center gutters-xs"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }